import config from './multilingualDigitalSouvenirs.json';

export const DIGITAL_SOUVENIR_LANGUAGE_ENTRIES = Array.isArray(config.languages)
  ? config.languages
  : [];

export const DIGITAL_SOUVENIR_X_DEFAULT_PATH = config.xDefaultPath || '/digital-souvenirs';
export const DIGITAL_SOUVENIR_ROBOTS =
  typeof config.robots === 'string' && config.robots.trim() ? config.robots.trim() : null;

export const DIGITAL_SOUVENIR_LANGUAGE_CODES = DIGITAL_SOUVENIR_LANGUAGE_ENTRIES.map(
  (entry) => entry.code
);

export const DIGITAL_SOUVENIR_NON_DEFAULT_LANGUAGE_CODES = DIGITAL_SOUVENIR_LANGUAGE_ENTRIES
  .filter((entry) => entry.code !== 'en')
  .map((entry) => entry.code);

export const getDigitalSouvenirLanguageEntry = (code) =>
  DIGITAL_SOUVENIR_LANGUAGE_ENTRIES.find((entry) => entry.code === code);

export const buildDigitalSouvenirAlternates = () => {
  const canonicalPath =
    DIGITAL_SOUVENIR_LANGUAGE_ENTRIES.find((entry) => entry.code === 'en')?.path ||
    DIGITAL_SOUVENIR_X_DEFAULT_PATH;

  return [
    {
      hrefLang: 'en',
      path: canonicalPath,
    },
    {
      hrefLang: 'x-default',
      path: canonicalPath,
    },
  ];
};
